import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const loginSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup
    .string()
    .min(6, "Minimum 6 characters")
    .required("Password is required"),
});

const LoginForm = ({ onSubmit, switchToSignup, switchToForgotPassword }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  return (
    <>
      <h1 className="auth-title">Welcome Back !</h1>
      <p className="auth-subtitle">Enter your details below</p>
      <form onSubmit={handleSubmit(onSubmit)} className="auth-form">
        <div className="form-field">
          <input type="email" placeholder="Email" {...register("email")} />
          {errors.email && <p className="error">{errors.email.message}</p>}
        </div>
        <div className="form-field">
          <input
            type="password"
            placeholder="Password"
            {...register("password")}
          />
          {errors.password && (
            <p className="error">{errors.password.message}</p>
          )}
        </div>
        <button type="submit" className="submit-button">
          Login
        </button>
        <div className="auth-footer">
          <a onClick={switchToForgotPassword} className="login-link">
            Forgot password?
          </a>
          <span> | </span>
          <a onClick={switchToSignup} className="login-link">
            Sign up
          </a>
        </div>
      </form>
    </>
  );
};

export default LoginForm;
